import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { CreateSearchResultBody, SearchResultApi } from 'api';

export const findRecentlySearchEntity = createAsyncThunk(
  'searchResult/findRecentlySearchEntity',
  async (options: any, { rejectWithValue }) => {
    try {
      const response = await SearchResultApi.findRecentlySearchEntity(options);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createSearchResult = createAsyncThunk(
  'searchResult/createSearchResult',
  async (query: CreateSearchResultBody, { rejectWithValue }) => {
    try {
      const response = await SearchResultApi.create(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeSearchResult = createAsyncThunk(
  'searchResult/removeSearchResult',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await SearchResultApi.remove(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: any[];
  data: any[];
  isLoading: boolean;
  reloadFlag: boolean;
}

const initState: IState = {
  tableList: [],
  isLoading: true,
  data: [],
  reloadFlag: false,
};

const searchResultSlice = createSlice({
  name: 'searchResult',
  initialState: initState,
  reducers: {
    reloadSearchResult(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder.addCase(findRecentlySearchEntity.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.data = data;
      state.isLoading = false;
    });
    builder.addCase(removeSearchResult.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.data = state.data.filter(item => item.id !== data.id);
    });
    builder.addCase(createSearchResult.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.data = data;
    });
  },
});

const { actions, reducer: searchResultReducer } = searchResultSlice;

export const { reloadSearchResult } = actions;

export default searchResultReducer;
